import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { CategoryInterface } from "../../../interfaces/categoryInterface";

type CategoryTableProps = {
  data: CategoryInterface[];
  isLoading: boolean;
} & Pick<
  DataTableProps<CategoryInterface>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<CategoryInterface>[] = [
  { key: "name", label: "Nombre" },
  { key: "active", label: "Activo", isBoolean: true },
];

export const CategoryTable = (props: CategoryTableProps) => {
  const { isLoading, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="category-table"
      customRender={(key, item) => {
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
